import { render, staticRenderFns } from "./PreviewFileField.vue?vue&type=template&id=f4b5f782&scoped=true&"
import script from "./PreviewFileField.vue?vue&type=script&lang=ts&"
export * from "./PreviewFileField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b5f782",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
